export enum ApprovalStatus {
  approved='approved',
  pending='pending',
  rejected='rejected'
}
